type GridEdge = 'left' | 'right';

// A row starts on the left in LTR and on the right in RTL; pin and lock a column to an edge through these.
export const leadingEdge = (enableRtl: boolean): GridEdge => (enableRtl ? 'right' : 'left');

export const trailingEdge = (enableRtl: boolean): GridEdge => (enableRtl ? 'left' : 'right');
